module.exports = __webpack_public_path__ + "static/media/dolphin.46fd87b9.ogg";